import { createSelector } from 'reselect';

export const selectEmailTemplateTypesSlice = state => state.emailTemplateTypes;

export const selectEmailTemplateTypes = createSelector(
  selectEmailTemplateTypesSlice,
  slice => slice.emailTemplateTypes
);

export const emailTemplateTypesMeta = createSelector(
  selectEmailTemplateTypesSlice,
  slice => slice.meta
);
export const emailTemplateTypesFilters = createSelector(
  selectEmailTemplateTypesSlice,
  slice => slice.filters
);
export const emailTemplateTypesErrors = createSelector(
  selectEmailTemplateTypesSlice,
  slice => slice.errors
);
